import { metricKeys } from '@pulse/metrics';
import { isNumber } from 'lodash';

export const dimensionTraceId = 'trace_id';
export const dimensionsShouldFilteroutUnknown = [dimensionTraceId];

export const networkMetrics = [
  metricKeys.AverageRequestDuration,
  metricKeys.AverageRequestCount,
  metricKeys.AppUniqueDevices,
];
/** metrics need to calculate sample secondary filter percentage */
export const metricsToCallSSFPct = [metricKeys.AverageRequestCount, metricKeys.AppUniqueDevices];

export const getSSFPctMetric = (metric) => `${metric}::ssfPct`;
export const getPctMetric = (metric) => `${metric}::pct`;

export function calcPercentage(total?: number, value?: number) {
  if (!isNumber(total) || !isNumber(value)) {
    return 'NA';
  }
  const pct = (value / total) * 100;
  return Number.isNaN(pct) || !Number.isFinite(pct) ? 'NA' : pct;
}

export enum ETableMode {
  drilldown = 'drilldown',
  filter = 'filter',
  compare = 'compare',
}

export const networkRequestUrlDimensions = {
  host: 'network_request_url_host',
  path: 'network_request_url_path',
  query: 'network_request_url_query',
};

export const dimensionRequestDuration = 'request_duration';
export const dimensionResponseCode = 'network_request_response_code';

export const reqeustDefaultDimensionList = [
  networkRequestUrlDimensions.host,
  networkRequestUrlDimensions.path,
  dimensionResponseCode,
];

export const requestDefaultFields = [
  {
    key: networkRequestUrlDimensions.host,
    displayName: 'Network Request Host',
    width: 300,
    sortable: false,
    disableClickAction: false,
    searchable: true,
  },
  {
    key: networkRequestUrlDimensions.path,
    displayName: 'Network Request Path',
    width: 300,
    sortable: false,
    disableClickAction: false,
    searchable: true,
  },
  {
    key: networkRequestUrlDimensions.query,
    displayName: 'Network Request Query',
    width: 300,
    sortable: false,
    disableClickAction: false,
    searchable: true,
  },
  {
    key: dimensionResponseCode,
    displayName: 'Response Code',
    width: 150,
    sortable: true,
    disableClickAction: false,
    searchable: true,
  },
  {
    key: dimensionRequestDuration,
    displayName: ' Network Request Duration',
    width: 200,
    sortable: true,
    disableClickAction: true,
  },
  {
    key: dimensionTraceId,
    displayName: 'Trace ID',
    width: 150,
    sortable: false,
    disableClickAction: true,
    searchable: true,
  },
];

export const EmptyArray = [];

export enum EActionKey {
  copy = 'copy',
  drillDown = 'drilldown_to_preset',
  traceId = 'traceId',
}

export const ZERO = 0;

export const EmptyColumnSearchData = {
  key: '',
  text: '',
};
